import { ECargo, NOMBRE_CARGO } from '@shared/types/enums'
import { ECertificationType, EDocumentStatus, EDocumentType, EEntidadFederativa, EGender, EPeriodType } from '@shared/types'
import { ICertificate } from '@shared/types/certificate'

export const CERTIFICATE_DATA: ICertificate = {
	data: {
		Alumno: {
			numeroControl: '',
			nombre: '',
			primerApellido: '',
			segundoApellido: '',
			curp: '',
			fechaNacimiento: new Date().toISOString(),
			idGenero: EGender.MALE
		},
		Asignaturas: {
			asignadas: 0,
			total: 0,
			totalCreditos: '',
			creditosObtenidos: '',
			promedio: '',
			numeroCiclos: 0,
			Asignatura: []
		},
		Carrera: {
			idCarrera: '',
			nombreCarrera: '',
			clavePlan: '',
			cveCarrera: '',
			idNivelEstudios: 0,
			idTipoPeriodo: EPeriodType.SEMESTRE,
			calificacionMaxima: 0,
			calificacionMinima: 0,
			calificacionMinimaAprobatoria: '',
			tipoPeriodo: 'SEMESTRE'
		},
		Expedicion: {
			fecha: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
			idLugarExpedicion: EEntidadFederativa.MEXICO,
			idTipoCertificacion: ECertificationType.TOTAL,
			tipoCertificacion: 'TOTAL',
			lugarExpedicion: {
				entidadFederativa: '',
				idEntidadFederativa: EEntidadFederativa.MEXICO
			}
		},
		FirmaResponsables: {},
		Ipes: {
			Responsable: {
				curp: '',
				nombre: '',
				primerApellido: '',
				segundoApellido: '',
				idCargo: ECargo.DIRECTOR,
				cargo: NOMBRE_CARGO[ECargo.DIRECTOR]
			},
			campus: '',
			entidadFederativa: '',
			idCampus: '',
			idEntidadFederativa: EEntidadFederativa.MEXICO,
			idNombreInstitucion: 0,
			nombreInstitucion: ''
		},
		Rvoe: {
			numero: '',
			fechaExpedicion: ''
		},
		numeroControl: ''
	},
	id: '',
	type: EDocumentType.CERTIFICATE,
	status: EDocumentStatus.PENDING,
	folioControl: '',
	date: new Date().getTime(),
	package: 0,
	success: false,
	warning: {
		message: '',
		code: '',
		error: {
			message: '',
			code: '',
			success: false,
			value: false
		},
		time: 0
	},
	error: {
		message: '',
		code: '',
		error: {
			message: '',
			code: '',
			success: false,
			value: false
		},
		time: 0
	}
}
